import { graphql } from '../graphql/generated';
import { useGraphQLQuery } from './useGraphQLRequest';
import { type ResultOf } from '@graphql-typed-document-node/core';

const PositionsGql = graphql(`
  query Positions($input: PositionQueryInput) {
    positions(input: $input) {
      id
      display_name
    }
  }
`);

type UsePositionsParams = {
  positionIds: number[];
};

export const usePositions = ({ positionIds }: UsePositionsParams) => {
  const { data, isLoading } = useGraphQLQuery<ResultOf<typeof PositionsGql>>({
    operationName: 'GetPositions',
    query: PositionsGql,
    variables: { input: { filter: { id: positionIds } } },
    enabled: positionIds.length > 0,
  });

  return {
    positions: data?.positions ?? [],
    isLoading,
  };
};
